<div>
  @if (withTitle) {
    <h3>Artikel</h3>
  }
  <table class="table whitetable marginless-bottom">
    <tbody>
      <tr>
        <td class="fixed-width-150">
          <strong>SDS-Nr.:</strong>
        </td>
        <td>
          @if (article.sds_nr) {
            <a title="Artikel öffnen"
              [href]="'/article/overview/' + article.oa_nr + workflowUrl | appHref" [target]="targetWindow"
              >
              <strong>{{ article.sds_nr }}</strong>
              @if (article.sds_nr.indexOf('-c') > 0 || article.sds_nr.indexOf('-C') > 0) {
                <i class="fa fa-warning" style="color:red;"
                [ngbTooltip]="'China-Artikel'"></i>
              }
            </a>
          }
        </td>
        <td colspan="2">
          @if (article.locked) {
            <span class="label label-warning">Gesperrt</span>
          }
          @if (!!article.data.special_production) {
            <div class="label label-danger">Spezial</div>
          }
          <ng-content select=".sds-projection"></ng-content>
        </td>
      </tr>
      <tr>
        <td class="fixed-width-150">0A-Nr.:</td>
        <td>
          <a title="Artikel öffnen" [href]="'/article/overview/' + article.oa_nr + workflowUrl | appHref" [target]="targetWindow">
            {{ article.oa_nr }}
          </a>
        </td>
        @if (!('article.wizard_create'|HasPerm) || !wizardForm) {
          <td>
          </td>
        }
        @if (('article.wizard_create'|HasPerm) && !!wizardForm) {
          <td>
            @if (wizardForm.data$|async; as form) {
              <article-wizard-button [oaNr]="article.oa_nr"
                [buttonLocked]="!!article.locked || !!article.date_deleted"
                [formStatus]="$safeNavigationMigration(form?.status)">
              </article-wizard-button>
            } @else {
              <ng-template [ngTemplateOutlet]="loadingOrError.template"></ng-template>
            }
            <loading-or-error
              #loadingOrError
              [loadingWrapper]="wizardForm"
              [errorMessage]="'Konnte \'Formular\' nicht laden'"
              [spinnerSize]="2"
              spinnerName="circle-o-notch">
            </loading-or-error>
          </td>
        }
      </tr>
      <tr>
        <td class="fixed-width-150">Kunden-Nr.:</td>
        <td colspan="3">
          <a title="Artikel öffnen" [href]="'/article/overview/' + article.oa_nr + workflowUrl | appHref" [target]="targetWindow">
            {{ article.data.kd_art_nr }}
          </a>
        </td>
      </tr>
      <tr>
        <td class="fixed-width-150">Kunden-Index:</td>
        <td colspan="3">
          <a title="Artikel öffnen" [href]="'/article/overview/' + article.oa_nr + workflowUrl | appHref" [target]="targetWindow">
            {{ article.data.kd_art_index }}
          </a>
        </td>
      </tr>
      <tr>
        <td class="fixed-width-150">Kundenbezeichnung 1:</td>
        <td colspan="3">
          <a title="Artikel öffnen" [href]="'/article/overview/' + article.oa_nr + workflowUrl | appHref" [target]="targetWindow">
            {{ article.data.kd_art_extend1 }}
          </a>
        </td>
      </tr>
      @if (inventory) {
        <tr>
          <td class="fixed-width-150">Lagerbestand:</td>
          <td colspan="3">
            <article-inventory-quantity-box [oaNr]="article.oa_nr"
              [workflowId]="workflowId"
              [inventory]="inventory"
              [showInventoryButton]="right"
              (reloadInventory)="reloadInventory.emit($event)">
            </article-inventory-quantity-box>
          </td>
        </tr>
      }
    </tbody>
  </table>
</div>
<ng-content></ng-content>
<div class="clearfix"></div>
